import React from 'react';
import Loadable from 'components/Loadable';
import {PrivateLayout} from 'components/Layouts';

import renderRoutes from 'pages/routes';

export default {
  exact: false,
  auth: true,
  path: '/user_trainers',
  component: ({routes}) => {
    return <PrivateLayout>{renderRoutes(routes)}</PrivateLayout>;
  },
  routes: [
    {
      exact: true,
      auth: true,
      path: '/user_trainers',
      component: Loadable({
        loader: () => import('./lists')
      })
    },
    {
      exact: true,
      auth: true,
      path: '/user_trainers/create',
      component: Loadable({
        loader: () => import('./create'),
      }),
    },
    {
      exact: true,
      auth: true,
      path: '/user_trainers/:mobile',
      component: Loadable({
        loader: () => import('./show'),
      }),
    },
    {
      exact: true,
      auth: true,
      path: '/user_trainers/:mobile/edit',
      component: Loadable({
        loader: () => import('./edit'),
      }),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/pages/back/user_trainers/index.js